import React from 'react'
import classNames from 'classnames'
import AspectRatio from './AspectRatio'

const ResponsiveImage = ({ className, file }) => {
  let srcSets = []

  if (!file || !file.hasOwnProperty('data')) {
    return null
  }

  file.data.thumbnails.forEach((thumbnail) => {
    if (thumbnail.url.indexOf('directus-') === -1) {
      srcSets.push(`${thumbnail.url} ${thumbnail.width}w`)
    }
  })

  const srcSet = srcSets.join(',')

  return (
    <AspectRatio ratio={file.height / file.width}>
      <img
        className={classNames('img-fluid w-100', className)}
        srcSet={srcSet}
        src={file.data.full_url}
        sizes="100vw"
        alt=""
      />
    </AspectRatio>
  )
}

export default ResponsiveImage
